import React from 'react';
import { StyleSheet, Text, View, Image, TouchableOpacity, Platform, Animated, Dimensions } from 'react-native';
import { SafeAreaView } from '../components';
import Colors from '../constants/Colors';
import CS from '../constants/Styles';
import { Button, Loader, BackgroundGradient, AppleAuthButton, FacebookAuthButton, GoogleAuthButton, TextInputContainer, Validate, MFAModal, Storage, Alert } from '../components';
import { processLoginAccount } from '../utils/Functions';
import * as AppleAuthentication from 'expo-apple-authentication';
import * as rtApi from '../components/Api';
import { useIsFocused } from '@react-navigation/native';
import * as LocalAthentication from 'expo-local-authentication';
import * as Application from 'expo-application';
import * as Location from 'expo-location';
import UserState from '../src/contexts/UserState';
import * as WebBrowser from 'expo-web-browser';
import { Entypo, FontAwesome, MaterialCommunityIcons, Ionicons } from '@expo/vector-icons';
import i18n from 'i18n-js';
import * as Localization from 'expo-localization';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import { useLinkTo } from '@react-navigation/native';
// import * as Analytics from 'expo-firebase-analytics';
import * as Updates from 'expo-updates';
import { isDev } from '../constants/DevProd';
import { isDesktop , isMobile } from 'react-device-detect';
import * as Sentry from 'sentry-expo';

const LoginScreen = ({ navigation, route, ...props}) => {
  const [user, setUser] = React.useContext(UserState);
  const defaultIsInvalid = { username: false, password: false };
  const [isInvalid, setIsInvalid] = React.useState(defaultIsInvalid);
  const [alertOptions, setAlertOptions] = React.useState({});
  const [passwordInputType, setPasswordInputType] = React.useState('password');
  
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [doLogin, setDoLogin] = React.useState(false);
  const [passwordLength, setPasswordLength] = React.useState(0);
  const [passwordLengthValid, setPasswordLengthValid] = React.useState(false);

  const [showMFA, setShowMFA] = React.useState(false);
  const [MFACode, setMFACode] = React.useState('');
  const [MFATrusted, setMFATrusted] = React.useState(true);
  const [MFARequired, setMFARequired] = React.useState(false);

  const [useLocalAuthentication, setUseLocalAuthentication] = React.useState(false);
  const [localAuthenticationButtonText, setLocalAuthenticationButtonText] = React.useState('');
  const [localAuthenticationType, setLocalAuthenticationType] = React.useState('');

  const [loginType, setLoginType] = React.useState('Email');
  const [uniqueDevice, setUniqueDevice] = React.useState(null);
  const [longitude, setLongitude] = React.useState(null);
  const [latitude, setLatitude] = React.useState(null);
  const [socialUser, setSocialUser] = React.useState(null);
  const [timezone, setTimezone] = React.useState(null);
  const [locale, setLocale] = React.useState(null);

  const [showEmailSignIn, setShowEmailSignIn] = React.useState(Platform.OS === 'web' ? true : false);
  // const [showEmailSignIn, setShowEmailSignIn] = React.useState(false);
  const [logoWebStyle, setLogoWebStyle] = React.useState({});
  const [howWebStyle, setHowWebStyle] = React.useState({});

  const [showCheckForUpdates, setShowCheckForUpdates] = React.useState(Platform.OS === 'web' ? false : (isDev ? true : false));

  const isFocused = useIsFocused();
  const linkTo = useLinkTo();
  const isMounted = React.useRef(false);
  const windowWidth = Dimensions.get('window').width;
  // let passwordInputY = 0;

  // const ac1 = new AbortController();
  // const ac2 = new AbortController();

  // React.useEffect(() => {
    // return () => {
    //   ac1.abort();
    //   ac2.abort();
    // }
  // }, []);

  let scrollRef = React.useRef(null);
  const fadeAnim = React.useRef(new Animated.Value(0)).current;
  const fadeIn = () => {
    console.log('fadein');
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration: 750,
      useNativeDriver: true,
    }).start();
  }
  React.useEffect(() => {
    isMounted.current = true;
    fadeIn();
    // checkUserSecureStore();
    checkLocalAuthenticationSecureStore();
    getUniqueDevice();
    getLocation();
    getLocalization();
    setLogoWebStyle(logoStyle(windowWidth));
    setHowWebStyle(howStyle(windowWidth));

    return () => { isMounted.current = false; }
  }, []);

  React.useEffect(() => {
    if(doLogin){
      performLogin();
    }
    return () => rtApi.cancel();
  }, [doLogin])

  React.useEffect(() => {
    checkMFACode();
  }, [MFACode])

  React.useEffect(() => {
    console.log('LOGIN route.params: ', route.params);
    if (route.params && route.params?.emailAddress){
      console.log('route.params?.emailAddress: ', route.params?.emailAddress);
      setUsername(route.params.emailAddress);
    }else{
      checkUserSecureStore();
    }
  }, [route.params])

  React.useEffect(() => {
    if(Platform.OS === 'web'){
      const subscription = Dimensions.addEventListener('change', onChangeDimensions);
      return () => {
        subscription.remove();
        // Dimensions.removeEventListener('change', onChangeDimensions);
      }
    }
  }, []);

  //app updates
  React.useEffect(() => {
    if(Platform.OS !== 'web'){
      checkForUpdates()
    }
  }, []);
  const checkForUpdates = async (manual) => {
    // setAlertOptions({
    //   visible: true,
    //   title: 'Update Available!',
    //   message: 'Would you like to download and install the update now?',
    //   buttons: [
    //     {
    //       text: 'Yes',
    //       onPress: () => reloadAppFromUpdate(),
    //       style: 'accept',
    //     },
    //     {
    //       text: 'No',
    //       onPress: () => { },
    //       style: 'cancel',
    //     },
    //   ]
    // });
    // return;
    try {
      const update = await Updates.checkForUpdateAsync();
      console.log('checkForUpdates: ', update);
      if (update.isAvailable) {
        await Updates.fetchUpdateAsync();
        setAlertOptions({
          visible: true,
          title: 'Update Available!',
          message: 'The latest update to the application has been downloaded. Press OK to restart the application and apply the update.',
          buttons: [
            {
              text: 'OK',
              onPress: () => reloadAppFromUpdate(),
              style: 'accept',
            },
            // {
            //   text: 'No',
            //   onPress: () => { },
            //   style: 'cancel',
            // },
          ]
        });
      }else{
        if(manual){
          setAlertOptions({
            visible: true,
            title: 'No Update Available.',
            message: 'You have the latest version of the app',
          });
        }
      }
    } catch (e) {
      // handle or log error
      console.log('error trying to check for updates: ', e);
      Sentry.Native.captureException(e);
    }
  }
  const reloadAppFromUpdate = async () => {
    console.log('reloading now')
    await Updates.reloadAsync();
  }

  const onChangeDimensions = ({ window, screen }) => {
    console.log('onChangeDimensions');
    setLogoWebStyle(logoStyle(window.width));
    setHowWebStyle(howStyle(window.width));
  };

  let textInputs = {
    username: React.useRef(null),
    password: React.useRef(null),
  };

  const getUniqueDevice = async () => {
    if(Platform.OS === 'ios'){
      setUniqueDevice(await Application.getIosIdForVendorAsync());
    }else if(Platform.OS === 'android'){
      setUniqueDevice(Application.androidId);
    }
  }
  const getLocation = async () => {
    let perm = await Location.getForegroundPermissionsAsync();
    console.log('getLocation', perm);
    if(perm.granted){
      let loc = await Location.getCurrentPositionAsync({ accuracy: Location.Accuracy.High });
      if (isMounted.current){
        setLongitude(loc.coords.longitude);
        setLatitude(loc.coords.latitude);
      }
    }
  }
  const getLocalization = async () => {
    let { timezone, locale } = await Localization.getLocalizationAsync();
    setTimezone(timezone);
    setLocale(locale);
  }

  const checkUserSecureStore = async () => {
    if(isMounted.current){
      // const username = await SecureStore.getItemAsync('username');
      const username = await Storage.getItem('username');
      if (username){
        console.log('setting username', username);
        setUsername(username);
      }
    }
  };

  const checkLocalAuthenticationSecureStore = async () => {
    // const result = await SecureStore.getItemAsync('useLocalAuthentication');
    const result = await Storage.getItem('useLocalAuthentication');
    if (result && result === 'yes') {
      setUseLocalAuthentication(true);
    }
    // setLocalAuthenticationButtonText(await SecureStore.getItemAsync('localAuthenticationButtonText'));
    // setLocalAuthenticationType(await SecureStore.getItemAsync('localAuthenticationType'));
    setLocalAuthenticationButtonText(await Storage.getItem('localAuthenticationButtonText'));
    setLocalAuthenticationType(await Storage.getItem('localAuthenticationType'));
  };

  const checkLogin = () => {
    console.log('checkLogin');
    setLoginType('Email');
    if(!Validate.Email(username)){
      setIsInvalid(prevState => { return { ...prevState, username: true } });
      textInputs.username.current.focus();
      return;
    }
    if (!Validate.Password(password)) {
      setIsInvalid(prevState => { return { ...prevState, password: true } });
      textInputs.password.current.focus();
      return;
    }
    emailApiLogin();
  }
  // const checkAutofillForLogin = () => {
  //   console.log('checkAutofillForLogin', username, password);
  //   setTimeout(() => {
  //     if (Validate.Email(username) && Validate.Password(password)) {
  //       emailApiLogin();
  //     }
  //   }, 250);
  // }
  const onChangeUsername = (username) => {
    if (isInvalid.username && Validate.Email(username)) {
      setIsInvalid(prevState => { return { ...prevState, username: false } });
    }
    setUsername(username);
  };
  const onChangePassword = (password) => {
    if(password.length !== 0){
      setUseLocalAuthentication(false);
    }else{
      checkLocalAuthenticationSecureStore();
    }

    if (isInvalid.password && Validate.Password(password)) {
      setIsInvalid(prevState => { return { ...prevState, password: false } });
    }
    setPassword(password);
    setPasswordLength(password.length);
    setPasswordLengthValid(password.length >= 15 ? true : false);
  };
  const performLogin = () => {
    if(loginType === 'Email'){
      emailApiLogin();
    }else{
      socialApiLoginWrapper();
    }
  }

  const buildEmailFormData = () => {
    let fd = new FormData();
    fd.append('username', username);
    fd.append('password', password);
    if(uniqueDevice){
      fd.append('unique_device', uniqueDevice);
    }
    if (longitude) {
      fd.append('longitude', longitude);
    }
    if (latitude) {
      fd.append('latitude', latitude);
    }
    if (MFARequired && MFACode) {
      fd.append('MFA', MFACode);
      fd.append('trusted', MFATrusted ? 1 : 0);
    }
    fd.append('time_zone', timezone);
    fd.append('language', locale);
    return fd;
  }
  const emailApiLogin = async () => {
    console.log('performing login', username, password);
    setLoading(true);
    setDoLogin(false);
    setShowMFA(false);
    
    const fd = buildEmailFormData();

    return rtApi.post('login', fd)
    .then(data => {
      console.log('request data', data);
      if (data.result) {
        // alert(JSON.stringify(data.session));
        logLogin(data.session.account);
        data.session.account.accepted_terms = 'No'; // TESTING accept terms
        let emailUser = processLoginAccount(data.session.account, true);
        checkUsernameSecureStore(emailUser); // sets loggedIn
      }else{
        // props.setLoggedIn(false);
        if(data.MFA){
          setShowMFA(true);
          setMFARequired(true);
        }
      }
    }).catch(err => {
      console.log('request err', err);
    }).finally(() => {
      setLoading(false);
    });
  }

  const checkUsernameSecureStore = async (u) => {
    if(u.type === 'Email'){
      // const uname = await SecureStore.getItemAsync('username');
      const uname = await Storage.getItem('username');
      console.log('checkUsernameSecureStore', username, uname);
      if (!uname || (uname !== username)) {
        console.log('deleting useLocalAuthentication');
        // await SecureStore.deleteItemAsync('useLocalAuthentication');
        await Storage.removeItem('useLocalAuthentication');
      }
      await Promise.all([
        // SecureStore.setItemAsync('username', String(username)),
        // SecureStore.setItemAsync('password', String(password)),
        Storage.setItem('userId', String(u.id)),
        Storage.setItem('username', String(username)),
        Storage.setItem('password', String(password)),
      ]);
    }else{
      // const uname = await Storage.getItem('username');
      // console.log('checkUsernameSecureStore', username, uname);
      // if (!uname || (uname !== username)) {
      //   console.log('deleting useLocalAuthentication');
      //   // await SecureStore.deleteItemAsync('useLocalAuthentication');
      //   await Storage.removeItem('useLocalAuthentication');
      // }
      await Promise.all([
        // SecureStore.deleteItemAsync('username'),
        // SecureStore.deleteItemAsync('password'),
        // SecureStore.setItemAsync('useLocalAuthentication', 'no'),
        Storage.removeItem('username'),
        Storage.removeItem('password'),
        Storage.removeItem('useLocalAuthentication'),
        // Storage.setItem('useLocalAuthentication', 'no'),
      ]);
    }
    setLoading(false);
    console.log('setting user login', user, u);
    setUser(u);
    console.log('setting user login 2', user);

    if (!u.terms_of_use){
      setAlertOptions({
        visible: true,
        title: 'Updated Terms of Use',
        message: 'To continue to use Renovation Trust you must agree to the newest terms of use.',
        buttons: [
          {
            text: 'OK',
            onPress: () => linkTo('/acceptterms'),
          },
        ]
      });
      // linkTo('/acceptterms');
    }
    // linkTo('/tutorials/my_first_project');

    return true;
  }
  
  const buildSocialFormData = (user, type) => {
    console.log('buildSocialFormData');
    let fd = new FormData();
    fd.append('user_id', user.id);
    fd.append('access_token', user.token);
    if(uniqueDevice){
      fd.append('unique_device', uniqueDevice);
    }
    if (longitude) {
      fd.append('longitude', longitude);
    }
    if (latitude) {
      fd.append('latitude', latitude);
    }
    if (MFARequired && MFACode) {
      fd.append('MFA', MFACode);
      fd.append('trusted', MFATrusted ? 1 : 0);
    }
    if (type === 'google') {
      fd.append('id_token', user.idToken);
    }
    fd.append('time_zone', timezone);
    fd.append('language', locale);
    fd.append('platform', Platform.OS);
    fd.append('environment', __DEV__ ? 'expogo'  : 'standalone');
    return fd;
  }
  const socialApiLogin = async (user, type) => {
    console.log('socialApiLogin', user, type);
    setLoading(true);
    return new Promise((resolve, reject) => {
      const fd = buildSocialFormData(user, type);

      rtApi.post('login/' + type, fd)
      .then(data => {
        resolve(data);
      }).catch(err => {
        reject(err);
      }).finally(() => {
        setLoading(false);
      });
    });
  }
  const socialApiLoginWrapper = async () => {
    // used when MFA is triggered on social login
    let sr = await socialApiLogin(socialUser, loginType.toLowerCase());
    if (sr.result) {
      let socialUser = processLoginAccount(sr.session.account, true);
      checkUsernameSecureStore(socialUser);
    } else {
      // Alert.alert('Error', 'Invalid Code');
      setAlertOptions({ visible: true, title: 'Error', message: `Invalid Code.` });
      setMFACode(null);
      showMFA(true);
    }
  }

  const localAuthentication = async () => {
    setLoginType('Email');
    let hasHardwareAsync = await LocalAthentication.hasHardwareAsync();
    console.log('hasHardwareAsync', hasHardwareAsync);
    if (hasHardwareAsync){
      let supportedAuthenticationTypesAsync = await LocalAthentication.supportedAuthenticationTypesAsync();
      console.log('supportedAuthenticationTypesAsync', supportedAuthenticationTypesAsync);
      if (supportedAuthenticationTypesAsync.length !== 0){
        let isEnrolledAsync = await LocalAthentication.isEnrolledAsync();
        console.log('isEnrolledAsync', isEnrolledAsync);
        if (isEnrolledAsync){
          let authenticateAsync = await LocalAthentication.authenticateAsync({
            promptMessage: 'Log into your renovation trust account with FaceId .. ?'
          });
          console.log('authenticateAsync', authenticateAsync);
          if (authenticateAsync.success){
            // let username = await SecureStore.getItemAsync('username');
            // let password = await SecureStore.getItemAsync('password');
            let username = await Storage.getItem('username');
            let password = await Storage.getItem('password');
            setUsername(username);
            setPassword(password);
            setDoLogin(true);
          }
        }
      }
    }
  }

  const checkMFACode = () => {
    console.log('MFACode', MFACode);
    if(String(MFACode).length === 6){
      setShowMFA(false);
      if (MFARequired){
        performLogin();
      } 
    }
  }
  const cancelMFA = () => {
    setShowMFA(false);
    setMFACode(null);
    setMFARequired(false);
  }

  const goToWebsite = () => {
    WebBrowser.openBrowserAsync('https://www.renovationtrust.com');
  }
  const showEmail = () => {
    setShowEmailSignIn(true);
  }
  const onSubmitUsername = () => {
    // console.log('scrolling to password input: ', passwordInputY);
    textInputs.password.current.focus();
    // setTimeout(() => {
    //   scrollRef.current.scrollTo({ x: 0, y: passwordInputY, animated: true });
    // }, 300);
  }

  const logoStyle = (windowWidth) => {
    if(Platform.OS === 'web'){
      const ratio = 344 / 936;
      let width = (windowWidth >= 768 ? 768 : windowWidth) * .80;
      if(width > 450){ width = 450; }
      console.log('logoStyle: ', width, width * ratio)
      return {
        // width: 450,
        // height: 165,
        width: width,
        height: width * ratio,
      }
    }
    return {};
  }
  const howStyle = (windowWidth) => {
    if(Platform.OS === 'web'){
      const ratio = 288 / 748;
      const width = windowWidth >= 768 ? 768 : windowWidth;
      console.log('logoStyle: ', width, width * ratio)
      return {
        // width: 748,
        // height: 288,
            // width: 768,
            // height: 296,
        // width: 540,
        // height: 208,
        width: width,
        height: width * ratio,
      }
    }
    return {};
  }

  const logLogin = async (user) => {
    console.log('logLogin');
    // await Promise.all([
    //   Analytics.setUserId(user.account_id),
    //   Analytics.setUserProperty('role', user.company_id ? 'Contractor' : 'Homeowner'),
    //   Analytics.logEvent('rt_login', {
    //     // user_id: user.id,
    //     type: 'email',
    //     platform: Platform.OS,
    //   }),
    // ]);
  }

  // const goToChrome = async () => {
  //   let result = await WebBrowser.openBrowserAsync('https://www.google.com/intl/en_ca/chrome/');
  // }

  const signUpContainerStyle = () => {
    if(Platform.OS === 'web' && isMobile){
      return {
        flexDirection: 'column',
        alignItems: 'center',
      }
    }
    return {};
  }

  const toggleShowPassword = () => {
    setPasswordInputType(passwordInputType === 'password' ? 'text' : 'password');
  }

  return (
    <SafeAreaView style={CS.safe}>
      <Animated.View style={[CS.container, {opacity: fadeAnim}]}>
        <BackgroundGradient />
        <Loader animating={loading} />
        <MFAModal
          show={showMFA}
          cancel={cancelMFA}
          setMFACode={setMFACode}
          setMFATrusted={setMFATrusted}
          showTrusted={true}
          MFATrusted={MFATrusted}
        />
        <Alert options={alertOptions} setOptions={setAlertOptions} />
        <KeyboardAwareScrollView style={styles.container} contentContainerStyle={styles.innerContainer} keyboardShouldPersistTaps='handled' ref={scrollRef}>
          <View style={styles.logoTextContainer}>
            <Image source={require('../assets/img/logo_border_text_white.png')} style={[CS.responsiveImage, styles.logoTextImage, logoWebStyle]} />
          </View>
          <TouchableOpacity style={styles.howContainer} activeOpacity={0.6} onPress={goToWebsite}>
            <Image source={require('../assets/img/how_we_protect.jpg')} style={[CS.responsiveImage, styles.howImg, howWebStyle]} />
            <View style={styles.howOverlay}>
              {/* <Text style={[CS.mediumText, CS.boldText, CS.lightText]}>How we protect homeowners and contractors <Entypo name="chevron-with-circle-right" size={22} color={Colors.lightGrey} /></Text> */}
              <Text style={[CS.mediumText, CS.boldText, CS.lightText]}>How we protect homeowners and contractors <Entypo name="chevron-with-circle-right" size={22} color={Colors.lightGrey} /></Text>
            </View>                
          </TouchableOpacity>
          {/* </Animated.View> */}
          {Platform.OS === 'ios' && AppleAuthentication.isAvailableAsync() && (
            <View style={styles.providerButton}>
              <AppleAuthButton
                setLoading={setLoading}
                navigation={navigation}
                setShowMFA={setShowMFA}
                setMFARequired={setMFARequired}
                setLoginType={setLoginType}
                socialApiLogin={socialApiLogin}
                setSocialUser={setSocialUser}
              />
            </View>
          )}
          <View style={styles.providerButton}>
            <FacebookAuthButton
              setLoading={setLoading}
              navigation={navigation}
              setShowMFA={setShowMFA}
              setMFARequired={setMFARequired}
              setLoginType={setLoginType}
              socialApiLogin={socialApiLogin}
              setSocialUser={setSocialUser}
            />
          </View>
          <View style={styles.providerButton}>
            <GoogleAuthButton
              setLoading={setLoading}
              navigation={navigation}
              setShowMFA={setShowMFA}
              setMFARequired={setMFARequired}
              setLoginType={setLoginType}
              socialApiLogin={socialApiLogin}
              setSocialUser={setSocialUser}
            />
          </View>
          
          
          {!showEmailSignIn && 
            <TouchableOpacity activeOpacity={0.6} onPress={showEmail} style={styles.showEmail}>
              <FontAwesome name="envelope" size={18} color={Colors.white} style={styles.showEmailIcon} />
              <Text style={[CS.smallText, CS.whiteText, CS.boldText]}>Sign in with Email</Text>
            </TouchableOpacity> 
          }
          {/* <OrSeparator /> */}
          {showEmailSignIn && 
            <>
            <TextInputContainer
              iconName='user'
              placeholder='Username'
              textContentType='username'
              onChangeText={(t) => onChangeUsername(t)}
              inputRef={textInputs.username}
              keyboardType='email-address'
              isInvalid={isInvalid.username}
              autoCapitalize='none'
              onSubmitEditing={onSubmitUsername}
              returnKeyType='next'
              value={username}
              spellCheck={false}
              onFocus={() => console.log('focus username')}
              onBlur={() => console.log('blur username')}
              onEndEditing={() => console.log('end editing username')}
            />
            {isFocused && (
              // <View onLayout={({ nativeEvent }) => { passwordInputY = nativeEvent.layout.y; console.log('on Layout: ', nativeEvent); }}>
              <View style={CS.passwordInputContainer}>
                <TextInputContainer
                  iconName='lock'
                  placeholder='Password'
                  textContentType={passwordInputType}
                  onChangeText={(t) => onChangePassword(t)}
                  inputRef={textInputs.password}
                  isInvalid={isInvalid.password}
                  autoCapitalize='none'
                  onSubmitEditing={() => checkLogin()}
                  returnKeyType='go'
                  value={password}
                  inputContainerStyle={{ marginBottom: 0, width: '100%' }}
                  onFocus={() => console.log('focus password')}
                  onBlur={() => console.log('blur password')}
                  onEndEditing={() => console.log('end editing password')}
                />
                <View style={styles.characterCount}>
                  <Text style={[CS.miniText, CS.redText, (passwordLengthValid && styles.validText)]}>{passwordLength}</Text>
                </View>
              </View>
            )}
            <View style={styles.passwordForgotContainer}>
              <TouchableOpacity activeOpacity={0.6} style={[CS.rowContainer, styles.checkboxContainer]} onPress={toggleShowPassword}>
                <Ionicons name={passwordInputType === 'text' ? 'checkbox-outline' : 'ios-square-outline'} size={24} color={Colors.lightBlue} style={styles.checkbox} />
                <Text style={[CS.smallText, CS.lightBlueText]}>Show password</Text>
              </TouchableOpacity>
              <TouchableOpacity onPress={() => linkTo('/forgotpassword')} style={styles.forgotContainer}>
                <Text style={styles.forgot}>Forgot Password?</Text>
              </TouchableOpacity>
            </View>
            {!useLocalAuthentication && (
              <Button text='Sign In' onPress={() => checkLogin} disabled={loading} />
            )}
            </>
          }
          
          {useLocalAuthentication && (
            <TouchableOpacity activeOpacity={0.6} onPress={localAuthentication} style={styles.localAuthenticationButton}>
              {localAuthenticationType === 'fingerprint' &&
                <MaterialCommunityIcons name="fingerprint" size={18} color={Colors.darkGrey} style={styles.showEmailIcon} />
              }
              {localAuthenticationType === 'facial' &&
                <MaterialCommunityIcons name="face-recognition" size={18} color={Colors.darkGrey} style={styles.showEmailIcon} />
              }
              <Text style={[CS.smallText, CS.darkText, CS.boldText]}>{localAuthenticationButtonText}</Text>
            </TouchableOpacity> 
          )}
          <View style={[styles.signUpContainer, signUpContainerStyle()]}>
            <Text style={styles.newText}>New to Renovation Trust?&nbsp;</Text>
            {/* <TouchableOpacity onPress={() => linkTo('/signup/emailpassword')}><Text style={styles.signUp}>{i18n.t('sign_up')}</Text></TouchableOpacity> */}
            <TouchableOpacity onPress={() => linkTo('/signup/emailpassword')}><Text style={styles.signUp}>Sign Up</Text></TouchableOpacity>
          </View>
          {showCheckForUpdates &&
            <View style={styles.signUpContainer}>
              <TouchableOpacity onPress={() => checkForUpdates(true)}><Text style={styles.signUp}>Check for updates</Text></TouchableOpacity>
            </View>
          }
        </KeyboardAwareScrollView>
      </Animated.View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    marginVertical: 10,
  },
  innerContainer: {
    width: '100%',
    // backgroundColor: 'blue',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    // justifyContent: Platform.OS === 'web' ? 'center' : 'flex-start',
    justifyContent: 'center',
    flexGrow: 1,
    alignSelf: 'center',
  },
  signUpContainer: {
    flexDirection: 'row',
    marginTop:20,
    justifyContent:'center'
  },
  signUp: {
    fontSize: 20,
    color: Colors.yellow,
    ...Platform.select({
      ios: {
        fontWeight: '900',
      },
      web: {
        fontWeight: '900',
      },
      android: {
        fontWeight: 'bold',
      }
    }),
  },
  passwordForgotContainer: {
    flexDirection: 'row',
    marginBottom:20,
  },
  checkboxContainer: {
    marginRight: 20,
    top: -12,
  },
  forgotContainer: {
    marginLeft: 'auto',
  },
  forgot: {
    color: Colors.lightText,
    alignSelf:'flex-end',
    fontSize: 20,
  },
  newText: {
    color: Colors.lightText,
    fontSize: 20,
    ...Platform.select({
      ios: {
        fontWeight: '300',
      },
      web: {
        fontWeight: '300',
      },
      android: {
        fontFamily: 'sans-serif-light',
      }
    }),
  },
  logoTextContainer: {
    width: '80%',
    alignSelf: 'center',
    alignItems: 'center',
  },
  logoTextImage: {
    marginBottom: 30,
    aspectRatio: 936 / 344,
  },
  providerButton: {
    marginBottom: 10,
  },
  howContainer: {
    borderRadius: 10,
    overflow: 'hidden',
    marginBottom: 20,
    justifyContent: 'center',
    borderColor: Colors.lightBlue,
    borderWidth: 1,
  },
  howImg: {
    aspectRatio: 748/288,
  },
  howOverlay: {
    backgroundColor: Colors.transparentBlue,
    position: 'absolute',
    top:0,
    left:0,
    height:'100%',
    width:'100%',
    padding:15,
    display:'flex',
    justifyContent: 'flex-end',
  },
  showEmail: {
    flexDirection: 'row',
    borderRadius: 5,
    backgroundColor: Colors.lightBlue,
    alignItems: 'center',
    justifyContent: 'center',
    padding:10,
  },
  showEmailIcon: {
    marginRight: 5,
  },
  localAuthenticationButton: {
    flexDirection: 'row',
    borderRadius: 5,
    backgroundColor: Colors.yellow,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10,
    marginTop: 10,
  },
  characterCount: {
    position: 'absolute',
    top: 0,
    right: 0,
    color: Colors.red,
    padding: 10,
    // width: 20,
    // backgroundColor: Colors.textInputBackground,
    backgroundColor: 'transparent',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  validText: {
    color: Colors.green,
  },
  checkbox: {
    marginRight: 5,
  },
});

export default React.memo(LoginScreen);
